module.exports = __webpack_public_path__ + "img/s.f2e82ee2.jpg";